<template>
  <div>
    <el-row style="margin-bottom: -20px;">
      <h4>客户名称：{{ customerName }}</h4>
      <h4>项目点名称：{{ projectName }}</h4>
    </el-row>
    <el-row style="margin-top:25px;">
      <el-col>
        <el-form size="small" :inline="true" class="demo-form-inline" :model="statusForm" :ref="statusForm"
          style="margin: 0">
          <el-col :xl="5" :lg="10" :md="10" :xs="10" :sm="10">
            <el-form-item label="名称：">
              <el-input size="medium" placeholder="名称" minlength="2" maxlength="10" v-model="statusForm.NAME" clearable
                @keyup.enter.native="filtrate()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="5" :lg="8" :md="12">
            <el-form-item label="状态：">
              <label slot="label">状&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;态：</label>
              <el-select size="medium" filterable v-model="statusForm.STATUS" placeholder="请选择" clearable>
                <el-option v-for="item in STATUS_LIST" :key="item.status" :label="item.name" :value="item.status">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="{ span: 1, offset: 1 }" :lg="1" :md="1">
            <el-button size="medium" type="primary" @click="filtrate()" :loading="loadSearch">筛选</el-button>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <el-button size="medium" @click="addUser()" style="margin-bottom:20px;" v-show="customerStatus !== 1">新增
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="dkList" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="ID" label="档口ID" min-width="100"></el-table-column>
          <el-table-column prop="NAME" label="名称" min-width="100"></el-table-column>
          <el-table-column prop="CODE" label="名称缩写" min-width="100"></el-table-column>
          <el-table-column prop="CUSTOM_CODE" label="打印编码" min-width="100"></el-table-column>
          <el-table-column fixed="right" label="操作" min-width="60" v-if="customerStatus !== 1">
            <template slot-scope="scope">
              <!-- <el-button type="text" size="small" icon="el-icon-edit-outline" v-if="scope.row.STATUS == 0 || pStatus == 0" disabled @click="edit(scope.row)">修改</el-button> -->
              <el-button type="text" size="small" icon="el-icon-edit-outline" v-if="scope.row.STATUS == 0" disabled
                @click="edit(scope.row)">修改</el-button>
              <el-button type="text" size="small" icon="el-icon-edit-outline" v-else @click="edit(scope.row)">修改
              </el-button>
              <el-button type="text" size="small" icon="el-icon-check" v-if="scope.row.STATUS == 0"
                style="color: rgb(103, 194, 58)" @click="startDK(scope.row)">启用</el-button>
              <el-button type="text" size="small" icon="el-icon-close" v-else @click="stopDK(scope.row)"
                style="color: rgb(245, 108, 108)">禁用</el-button>
              <el-button type="text" size="small" icon="el-icon-edit-outline" @click="printCode(scope.row)">打印编码
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 新增档口模态框 -->
    <el-dialog title="新增档口" center :visible.sync="addFormVisible" width="600px">
      <el-form size="small" :model="addForm" ref="addForm" :rules="rules" style="margin-top: 0">
        <el-form-item label="档口名称：" :label-width="formLabelWidth" prop="NAME">
          <el-input v-model="addForm.NAME" auto-complete="off" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="名称缩写：" :label-width="formLabelWidth" prop="CODE">
          <el-input v-model="addForm.CODE" auto-complete="off" clearable></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('addForm')">取 消</el-button>
        <el-button size="small" @click="submitAction('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 自定义打印编码模态框 -->
    <el-dialog title="自定义打印编码" center :visible.sync="printCodeFormVisible" width="400px">
      <el-form size="small" :model="printCodeForm" ref="printCodeForm" :rules="rules" style="margin-top: 0">
        <el-form-item label="编码：" :label-width="formLabelWidth" prop="CUSTOM_CODE">
          <el-input v-model="printCodeForm.CUSTOM_CODE" auto-complete="off" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closePrintCodeFormVisible">取 消</el-button>
        <el-button size="small" @click="submitPrintCode">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getDkList, addDK, stopDK, startDK, printCODE,
} from 'api/customerManage';

export default {
  data() {
    return {
      loading: false,
      loadSearch: false,
      dkList: [],
      pStatus: sessionStorage.getItem('status'),
      addFormVisible: false,
      pageSize: 10,
      currentPage: 1,
      totalNum: 0,
      // 新增form表单
      addForm: {},
      formLabelWidth: '100px',
      rules: {
        NAME: [
          { required: true, message: '请输入档口名称', trigger: 'blur' },
        ],
        // CODE: [
        //   { required: true, message: '请输入档口名称缩写', trigger: 'blur' },
        // ],
        CUSTOM_CODE: [
          { required: true, message: '请输入自定义编码', trigger: 'blur' },
        ],
      },
      dialogFlag: 0,
      statusForm: {
        STATUS: -1,
      },
      customerStatus: Number(sessionStorage.getItem('customerStatus')),
      printCodeFormVisible: false,
      printCodeForm: [],
      customerName: sessionStorage.getItem('customerName') || '',
      projectName: sessionStorage.getItem('projectName') || '',
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryDKList();
  },
  computed: {
    STATUS_LIST() {
      return [{ status: -1, name: '全部' }, { status: 0, name: '禁用' }, { status: 1, name: '在用' }];
    },
  },
  methods: {
    // ------------------筛选
    filtrate() {
      this.queryDKList();
      // let data = {
      //     PROJECT_ID: sessionStorage.getItem('projectId')
      // }
      // if (this.statusForm.NAME) {
      //     data.DK_NAME = this.statusForm.NAME
      // }
      // for (let key in this.statusForm) {
      //   if (this.statusForm[key] !== undefined && this.statusForm[key] !== null) {
      //     if (key === 'STATUS') {
      //       this.statusForm[key] = Number(this.statusForm[key])
      //     }
      //     data[key] = this.statusForm[key]
      //   }
      // }
      // if (JSON.stringify(data) !== '{}') {
      //       getDkList(data).then(res=>{
      //         this.dkList = res.length > 0 ? res : []
      //         this.totalNum = res.length > 0 ? res.TOTAL_COUNT : 0
      //     }).catch(error=>{
      //         this.$message.show({text: error, type: 'error'});
      //     })
      // } else {
      //   this.$message.show({text: '无筛选条件', type: 'warning'})
      // }
    },
    // ---------------------拉取
    queryDKList() {
      const data = {
        PROJECT_ID: sessionStorage.getItem('projectId'),
        STATUS: this.statusForm.STATUS,
      };
      if (this.statusForm.NAME) {
        data.DK_NAME = this.statusForm.NAME;
      }
      this.loadSearch = true;
      getDkList(data).then((res) => {
        this.dkList = res.length > 0 ? res : [];
        this.totalNum = res.length > 0 ? res.TOTAL_COUNT : 0;
        this.loadSearch = false;
      }).catch((error) => {
        this.loadSearch = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增弹窗
    addUser() {
      this.addFormVisible = true;
      this.dialogFlag = 0;
    },
    // 修改弹窗
    edit(row) {
      this.addFormVisible = true;
      this.addForm = row;
      this.dialogFlag = 1;
    },
    // 新增档口
    submitAction(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialogFlag === 0) {
            this.addDKFun(1);
          } else {
            this.addDKFun(3);
          }
        }
      });
    },
    addDKFun(OTYPE) {
      this.loading = true;
      const data = {
        PROJECT_ID: sessionStorage.getItem('projectId'),
        // CODE: this.addForm.CODE,
        NAME: this.addForm.NAME,
      };
      if (this.addForm.ID) {
        data.DK_ID = this.addForm.ID;
      }
      // if (this.addForm.CODE) {
      //   const reg = /[\u4E00-\u9FA5]/g;
      //   if (reg.test(this.addForm.CODE)) {
      //     this.$message.show({ text: '请不要输入汉字', type: 'warning' });
      //     document.body.style.cursor = 'default';
      //     return false;
      //   }
      // }
      addDK(data, OTYPE).then((res) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.queryDKList();
        this.addFormVisible = false;
        this.addForm = {};
        this.loading = false;
      }).catch((error) => {
        this.$message.show({ text: '操作失败', type: 'error' });
        this.loading = false;
      });
    },
    // ---------------------禁用档口
    stopDK(row) {
      this.$confirm('您确定禁用该档口吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = { // http请求的参数
          DK_ID: row.ID,
        };
        stopDK(data).then((res) => {
          this.$message.show({ text: '禁用成功', type: 'success' });
          this.queryDKList();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '取消操作' });
      });
    },
    startDK(row) {
      this.$confirm('您确定启用该档口吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = { // http请求的参数
          DK_ID: row.ID,
        };
        startDK(data).then((res) => {
          this.$message.show({ text: '启用成功', type: 'success' });
          this.queryDKList();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '取消操作' });
      });
    },
    // 关闭弹窗
    close() {
      this.addFormVisible = false;
      this.queryDKList();
    },
    // close(formName){
    //   this.$refs[formName].resetFields();
    //   let modalName=formName+'Visible'
    //   this[`${modalName}`]=false
    // }
    // 自定义编码打印
    printCode(row) {
      this.printCodeFormVisible = true;
      this.printCodeForm = row;
    },
    submitPrintCode() {
      const data = {
        DK_ID: this.printCodeForm.ID,
        CUSTOM_CODE: this.printCodeForm.CUSTOM_CODE,
      };
      printCODE(data).then((res) => {
        this.printCodeFormVisible = false;
        this.queryDKList();
      }).catch((error) => {
        this.printCodeFormVisible = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    closePrintCodeFormVisible() {
      this.printCodeFormVisible = false;
    },
  },
};
</script>

<style scoped>
.el-row>>>h4 {
  display: inline-block;
  padding-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/customerManage/dkList.vue